<section class="incoming-call-modal" aria-label="Incoming call">
  <div class="incoming-call-modal__halo" aria-hidden="true"></div>

  <header class="incoming-call-modal__header">
    <p class="incoming-call-modal__eyebrow">Incoming {{ getModeLabel() }}</p>
    <h2>{{ data.incomingCall.started_by_name || 'Someone' }}</h2>
    <p class="incoming-call-modal__channel">{{ data.channelName }}</p>
  </header>

  <div class="incoming-call-modal__icon" aria-hidden="true">
    <mat-icon>{{ getCallIcon() }}</mat-icon>
  </div>

  <footer class="incoming-call-modal__actions">
    <button type="button" mat-stroked-button color="primary" (click)="dismiss()">Dismiss</button>
    <button type="button" mat-flat-button color="primary" (click)="answer()">
      <mat-icon aria-hidden="true">{{ getCallIcon() }}</mat-icon>
      Answer
    </button>
  </footer>
</section>
